module.exports = __webpack_public_path__ + "img/monochromatic.472fc6c0.jpg";